import {IActionFn, IPageData} from '@/store/types';
import {IItemResult, IModuleState} from './types';
import {$http} from '@/axios';
import store from '@/store';

// 查询专案组列表
export const queryGroups: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setGroups', {...state.list, loading: true});
        // const { list, pageNum, pageSize, total } = await $http.post('/design/group/list', payload);
        const res: IPageData = await $http.post('/v1/design/dpg/pagelist', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setGroups', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setGroups', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询展示列表
export const queryDpsPage: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDpsPage', {...state.dpsPage, loading: true});
        const res: IPageData = await $http.post('/design/project/show/list/platform', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setDpsPage', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setDpsPage', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询展示列表
export const queryDpscPage: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDpscPage', {...state.dpscPage, loading: true});
        const res: IPageData = await $http.post('/design/project/show/content/list/platform', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setDpscPage', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setDpscPage', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};


// 查询无效专案列表
export const queryInvalidGroups: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setGroups', {...state.list, loading: true});
        const res: IPageData = await $http.post('/v1/design/dpg/pagelist', {...payload, status: [0]});
        const {list: data, pageNum, pageSize, total} = res;
        commit('setGroups', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setGroups', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询专案组详情
export const queryDetail: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDetail', {data: null, loading: true});
        // const res = await $http.get(`/design/group/platform/get/${payload}`);
        const res = await $http.get(`/v1/design/dpg/${payload}/detail`);
        commit('setDetail', {data: res});
    } catch (e) {
        commit('setDetail', {data: null});
    }
};

// 查询组织下拉列表(交付时需要)
export const queryOrgs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setOrgs', {...state.orgs, loading: true});
        const res = await $http.post('/v1/data/system/org/channelorgs', payload);
        commit('setOrgs', {data: res});
    } catch (e) {
        commit('setOrgs', {data: []});
    }
};

// 查询专案物品和材料列表
export const queryMatLibs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setModels', {data: [], loading: true});
        commit('setMaterials', {data: [], loading: true});
        // const res: IItemResult = await $http.post('design/group/lib/item/list', payload);
        const res: IItemResult = await $http.post('/v1/design/dpg/listforlib', payload);
        commit('setModels', {data: res?.designProjectModelItemDtos || []});
        commit('setMaterials', {data: res?.designProjectMaterialInstanceItemDtos || []});
    } catch (e) {
        commit('setModels', {data: []});
        commit('setMaterials', {data: []});
    }
};

// 查询操作日志
export const queryOperateLogs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLogs', {...state.logs, loading: true});
        // const { list, pageNum, pageSize, total } = await $http.post('/design/transfer/log/search', payload);
        const res: IPageData = await $http.post('/v1/design/dpg/searchlogfortransfer', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setLogs', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setLogs', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询专案库调整日志(右库)
export const queryAdjustLogs: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLogs', {...state.logs, loading: true});
        // const { list = [], pageNum, pageSize, total } = await $http.post('/design/item/log/list', payload);
        const res: IPageData = await $http.post('/v1/design/dpg/logforitem', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setLogs', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setLogs', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询状态字典
export const queryStatusTypes: IActionFn<IModuleState> = async ({commit, state}) => {
    try {
        commit('setStatusTypes', {...state.statusTypes, loading: true});
        const res: any[] = await $http.get('/common/chooseoptions/DesignProjectStatus');
        commit('setStatusTypes', {data: [{optionKey: '', optionValue: '全部'}, ...res]});
    } catch (e) {
        commit('setStatusTypes', {data: []});
    }
};

// 编辑专案组
export const editGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLoading', true);
        // await $http.post('/design/group/modify', payload);
        await $http.post('/v1/design/dpg/modify', payload);
        store.commit('common/setToast', {visible: true, text: '编辑成功'});
    } finally {
        commit('setLoading', false);
    }
};

// 批量上下架专案组
export const batchShelfGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    commit('setConfirm', {...state.confirm, loading: true});

    if (payload.operate === false) {
        // 下架
        try {
            // await $http.post('/design/group/batch/shelf', payload);
            await $http.post('/v1/design/dpg/shelf', payload);
        } finally {
            commit('setConfirm', {visible: false});
        }
    } else if (payload.operate === true && payload.release !== true) {
        // 发布
        try {
            // 发送请求的时候忽略了 1626 业务错误，所以不会进 catch 分支
            // const res: any = await $http.post('/design/group/batch/shelf', payload, { ignoreCode: [1626] });
            const res: any = await $http.post('/v1/design/dpg/shelf', payload, {ignoreCode: [1626]});
            // 如果出现了 1626 业务错误，说明发布的专案组里存在未发布的物料，此时打开再次确认发布弹窗
            const visible = res?.rtnCode === 1626;
            const data = JSON.parse((res?.data || [])[0] || '[]')[0];
            commit('setShelfCheck', {visible, data, params: payload});
            store.commit('common/setToast', {visible: !visible, text: '发布成功'});
        } finally {
            commit('setConfirm', {visible: false});
        }
    } else if (payload.operate === true && payload.release === true) {
        // 再次确认发布（强制发布）
        try {
            commit('setShelfCheck', {...state.shelfCheck, loading: true});
            // await $http.post('/design/group/batch/shelf', payload);
            await $http.post('/v1/design/dpg/shelf', payload);
            store.commit('common/setToast', {visible: true, text: '发布成功'});
        } finally {
            commit('setShelfCheck', {visible: false});
        }
    }
};

// 批量删除专案组
export const batchDeleteGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        // await $http.post('/design/group/batch/delete', payload);
        await $http.post('/v1/design/dpg/delete', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

export const deleteDps: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/design/project/show/delete/platform', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

export const saveDps: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLoading', true);
        const form = new FormData();
        const file = payload.file;
        delete payload.file;
        form.append('command', new Blob([JSON.stringify(payload)], {type: 'application/json'}));
        form.append('file', file);
        await $http.post('/design/project/show/save/platform', form);
    } finally {
        commit('setLoading', false);
    }
};

export const deleteDpsc: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/design/project/show/content/delete/platform', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

export const saveDpsc: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLoading', true);
        const file = payload.file;
        delete payload.file;
        const form = new FormData();
        form.append('command', new Blob([JSON.stringify(payload)], {type: 'application/json'}));
        form.append('file', file);
        await $http.post('/design/project/show/content/save/platform', form);
    } finally {
        commit('setLoading', false);
    }
};

// 批量转换专案的物料库(物料库从旧版升级到新版)
export const batchUpgradeGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        const res: any = await $http.post('/v1/design/dpg/extractassetsfromoldfile', payload, {ignoreCode: [1616, 1618]});
        const rtnCode = res?.rtnCode || 0;
        // 如果转换失败，则将打开转换信息提示框
        if ([1616, 1618].indexOf(rtnCode) !== -1) {
            const data = JSON.parse(res.message);
            commit('setUpgradeCheck', {visible: true, type: `${rtnCode}`, data});
            return false;
        } else {
            return true;
        }
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 交付(将平台专案组复制到指定组织下)
export const deliverGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        // await $http.post('/design/group/transfer', payload);
        await $http.post('/v1/design/dpg/transfer', payload);
        store.commit('common/setToast', {visible: true, text: '交付成功'});
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 收集(将非平台专案组复制到平台下)
export const collectGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        // await $http.post('/design/group/transfer', payload);
        await $http.post('/v1/design/dpg/transfer', payload);
        store.commit('common/setToast', {visible: true, text: '收集成功'});
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 查询初始过滤项配置
export const queryFilter: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setFilters', {data: [], loading: true});
        // const res = await $http.post('/design/group/filter/list', payload);
        const res = await $http.post('/v1/design/dpg/filter/list', payload);
        commit('setFilters', {data: res, loading: false});
    } catch (e) {
        commit('setFilters', {data: [], loading: false});
    }
};

// 批量删除过滤项配置
export const deleteFilter: IActionFn<IModuleState> = async ({commit}, payload) => {
    try {
        // await $http.post('/design/group/filter/delete', payload);
        await $http.post('/v1/design/dpg/filter/delete', payload);
        return true;
    } catch (e) {
        return false;
    }
};

// 保存过滤项配置
export const saveFilter: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    // await $http.post('/design/group/filter/batch/modify', payload);
    await $http.post('/v1/design/dpg/filter/modify', payload);
    store.commit('common/setToast', {visible: true, text: '保存成功'});
};

// 查询待添加的物品列表(左库)
export const queryAllMatModels: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setAllMatModels', {...state.allModels, data: [], loading: true});
        const res: IPageData = await $http.post('/v1/data/asset/item/search', payload);
        commit('setAllMatModels', {data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total});
    } catch (e) {
        commit('setAllMatModels', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询待添加的材料列表(左库)
export const queryAllMatMaterials: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setAllMatMaterials', {...state.allMaterials, data: [], loading: true});
        const res: IPageData = await $http.post('/v1/data/asset/material/search', payload);
        commit('setAllMatMaterials', {data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total});
    } catch (e) {
        commit('setAllMatMaterials', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 批量新增专案物品(右库)
export const batchAddModel: IActionFn<IModuleState> = async ({commit}, payload) => {
    try {
        // await $http.post('/design/item/model/batch/add', payload);
        await $http.post('/v1/client/design/dpg/additems', payload);
        store.commit('common/setToast', {visible: true, text: '新增成功'});
        return true;
    } catch (e) {
        return false;
    }
};

// 批量新增专案材料(右库)
export const batchAddMaterial: IActionFn<IModuleState> = async ({commit}, payload) => {
    try {
        // await $http.post('/design/item/material/batch/add', payload);
        await $http.post('/v1/client/design/dpg/addmaterials', payload);
        store.commit('common/setToast', {visible: true, text: '新增成功'});
        return true;
    } catch (e) {
        return false;
    }
};

// 批量删除专案物品(右库)
export const batchDeleteModel: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        // await $http.post('/design/item/model/batch/delete', payload);
        await $http.post('/v1/client/design/dgp/removeitems', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 批量删除专案材料(右库)
export const batchDeleteMaterial: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        // await $http.post('/design/item/material/batch/delete', payload);
        await $http.post('/v1/client/design/dpg/removematerials', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 查询光照配置(功能已被隐藏)
export const queryEnvLight: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setEnvLight', {data: null, loading: true});
        const res = await $http.post('/v1/design/dpg/scenelight', payload);
        commit('setEnvLight', {data: res});
    } catch (e) {
        commit('setEnvLight', {data: null});
    }
};

// 保存光照配置(功能已被隐藏)
export const saveEnvLight: IActionFn<IModuleState> = async ({commit}, payload) => {
    await $http.post('/v1/design/dpg/updatescenelight', payload);
    store.commit('common/setToast', {visible: true, text: '保存成功'});
};

// 查询已删除的专案列表
export const queryRestoreList: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setRestoreList', {...state.restoreList, loading: true});
        // const { list, pageNum, pageSize, total } = await $http.post('/design/group/restorepagelist', payload);
        const res: IPageData = await $http.post('/v1/design/dpg/restorepagelist', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setRestoreList', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setRestoreList', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 批量还原已删除的专案
export const restoreGroup: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        // await $http.post('/design/group/restore', payload);
        await $http.post('/v1/design/dpg/restore', payload);
        store.commit('common/setToast', {visible: true, text: '恢复成功'});
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 将专案组转换为杂志
export const dpgToMagazine: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/design/dpgtomagazine', payload);
        store.commit('common/setToast', {visible: true, text: '保存成功'});
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 查询子专案里的拼装家具列表
export const queryFurByDpj: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLibFurs', {...state.libFurs, loading: true});
        const res = await $http.post('/v1/data/design/furnitureitemlist', payload);
        commit('setLibFurs', {data: res});
    } catch (e) {
        commit('setLibFurs', {data: []});
    }
};

// 复制物料或拼装家具
export const copyLibItems: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/client/design/group/copyitems', payload);
        store.commit('common/setToast', {visible: true, text: '导入成功'});
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 仅复制拼装家具
export const copyLibFurniture: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDialog', {...state.dialog, loading: true});
        await $http.post('/v1/client/design/group/copyfurnitureitems', payload);
        store.commit('common/setToast', {visible: true, text: '导入成功'});
    } finally {
        commit('setDialog', {visible: false});
    }
};

// 校验展示是否支持移动端可进入
export const validateMobileAccessible: IActionFn<IModuleState> = async (_, showCode) => {
    try {
        const res = await $http.get(`/v1/admin/design/show/${showCode}/mobile-accessible/validate`);
        return res;
    } catch (e) {
        return {valid: false, nonSupportItems: [], message: '校验失败'};
    }
};

// 更新展示的移动端可进入状态
export const updateMobileAccessible: IActionFn<IModuleState> = async (_, payload) => {
    try {
        await $http.put('/v1/admin/design/show/mobile-accessible', payload);
        store.commit('common/setToast', {visible: true, text: '更新成功'});
        return true;
    } catch (e) {
        const errorMsg = (e as any)?.message || '更新失败';
        store.commit('common/setToast', {visible: true, text: errorMsg});
        return false;
    }
};

